import { Injectable } from '@angular/core';
import { AdalService } from './adal.service';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from './adal.service';
var AdalGuard = /** @class */ (function () {
    function AdalGuard(adalService) {
        this.adalService = adalService;
    }
    AdalGuard.prototype.canActivate = function (route, state) {
        return this.adalService.userInfo.authenticated;
    };
    AdalGuard.prototype.canActivateChild = function (childRoute, state) {
        return this.canActivate(childRoute, state);
    };
    /** @nocollapse */
    AdalGuard.ctorParameters = function () { return [
        { type: AdalService }
    ]; };
AdalGuard.ɵfac = function AdalGuard_Factory(t) { return new (t || AdalGuard)(ɵngcc0.ɵɵinject(ɵngcc1.AdalService)); };
AdalGuard.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AdalGuard, factory: function (t) { return AdalGuard.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AdalGuard, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.AdalService }]; }, null); })();
    return AdalGuard;
}());
export { AdalGuard };

